export default __webpack_public_path__ + "static/media/gear-icon.5d2028e6.svg";